/* leaflet map */
(function($) {

    /**
     * initMap
     *
     * Renders a Leaflet Map onto the selected jQuery element
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
        // Find marker elements within map
        var $markers = $el.find('.marker');
        
        // Create map instance
        var mapArgs = {
            zoom: $el.data('zoom') || 11,
            maxZoom: 16,
            zoomControl: true,
        };
        
        // Create map
        var map = L.map($el[0], {
            center: [0, 0],
            zoom: mapArgs.zoom,
            maxZoom: mapArgs.maxZoom,
            zoomControl: mapArgs.zoomControl
        });
        
        // Add OpenStreetMap tile layer with custom styling
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        
        // Add markers
        map.markers = [];
        $markers.each(function() {
            initMarker($(this), map);
        });
        
        // Center map based on markers
        centerMap(map);
        
        // Return map instance
        return map;
    }
    
    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @param   jQuery $marker The jQuery element.
     * @param   object map The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
        // Get position from marker
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = [parseFloat(lat), parseFloat(lng)];
        
        // Get additional data from marker
        var iconUrl = $marker.data('iconbig') || null;
        var garageId = $marker.data('garage') || null;
        
        // Create default icon (small red dot SVG)
        var defaultIcon = L.divIcon({
            html: '<svg width="24.92" height="24.92" viewBox="0 0 24.92 24.92" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="12.46" cy="12.46" r="12.46" fill="#dc0613" opacity=".26"/><circle cx="12.46" cy="12.46" r="7.78" fill="#dc0613"/></svg>',
            className: 'leaflet-marker-icon',
            iconSize: [30, 30],
            iconAnchor: [15, 15]
        });
        
        // Toujours utiliser l'icône SVG par défaut au départ
        var marker = L.marker(latLng, {
            icon: defaultIcon
        }).addTo(map);
        
        // Store additional data with marker for later use
        marker.garage = garageId;
        marker.iconbig = iconUrl;
        
        // Add to markers array
        map.markers.push(marker);
        
        // If marker contains HTML, add it to a popup
        if ($marker.html()) {
            marker.bindPopup($marker.html());
        }
        
        return marker;
    }
    
    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @param   object map The map instance.
     * @return  void
     */
    function centerMap(map) {
        // Create bounds
        var bounds = L.latLngBounds();
        
        // Add each marker to bounds
        map.markers.forEach(function(marker) {
            bounds.extend(marker.getLatLng());
        });
        
        // If there are markers, fit bounds
        if (map.markers.length > 0) {
            // Case: Single marker
            if (map.markers.length == 1) {
                map.setView(bounds.getCenter(), map.getZoom());
            } 
            // Case: Multiple markers
            else {
                map.fitBounds(bounds);
            }
        }
    }
    
    // Breakpoint detection function
    var isBreakPoint = function(bp) {
        var bps = [320, 480, 768, 992, 1199],
            w = $(window).width(),
            min, max;
        for (var i = 0, l = bps.length; i < l; i++) {
            if (bps[i] === bp) {
                min = bps[i-1] || 0;
                max = bps[i];
                break;
            }
        }
        return w > min && w <= max;
    };
    
    // Render maps on page load
    var map;
    $(document).ready(function() {
        $('.acf-map').each(function() {
            map = initMap($(this));
            
            // Ajuster la vue de la carte en fonction de la taille de l'écran
            // Utiliser setView au lieu de panBy pour éviter les erreurs de coordonnées
            if (!(isBreakPoint(992) || isBreakPoint(320) || isBreakPoint(480) || isBreakPoint(768))) {
                // Sur les grands écrans, décaler légèrement la vue vers la gauche
                setTimeout(function() {
                    var center = map.getCenter();
                    map.setView(center, map.getZoom(), {
                        pan: {
                            animate: true
                        }
                    });
                }, 100);
            }
        });
        
        // Set active elements
        $('.garages_list_contact--item[data-garagename="ans"]').addClass('active');
        if ($('.garages_gallery--wrapper').length) {
            $('.garages_gallery--wrapper[data-gallery="ans"]').addClass('active');
        }
        if ($('.garages_horaires').length) {
            $('.garages_horaires[data-garage="ans"]').addClass('active');
        }
        
        // S'assurer que tous les marqueurs utilisent l'icône SVG par défaut au chargement
        if (map && map.markers) {
            map.markers.forEach(function(marker) {
                var defaultIcon = L.divIcon({
                    html: '<svg width="24.92" height="24.92" viewBox="0 0 24.92 24.92" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="12.46" cy="12.46" r="12.46" fill="#dc0613" opacity=".26"/><circle cx="12.46" cy="12.46" r="7.78" fill="#dc0613"/></svg>',
                    className: 'leaflet-marker-icon',
                    iconSize: [30, 30],
                    iconAnchor: [15, 15]
                });
                marker.setIcon(defaultIcon);
            });
        }
        
        // Handle hover events for garage list items
        $(".garages_list--item, .garages_list_contact--item").on("mouseover", function() {
            var item = $(this);
            var garageImage = item.data('image');
            var garageName = item.data('garagename');
            
            // Update garage name and image
            $('.garages_photo--name').find('span').text(garageName);
            $('.garages_photo--image').attr('src', garageImage);
            
            // Update gallery if it exists
            if ($('.garages_gallery--wrapper').length) {
                $('.garages_gallery--wrapper').removeClass('active');
                $('.garages_gallery--wrapper[data-gallery="' + garageName + '"]').addClass('active');
            }
            
            // Update hours if they exist
            if ($('.garages_horaires').length) {
                $('.garages_horaires').removeClass('active');
                $('.garages_horaires--days').removeClass('active');
                $('.garages_horaires[data-garage="' + garageName + '"] .tab_content a').removeClass('active');
                
                $('.garages_horaires[data-garage="' + garageName + '"]').addClass('active');
                $('.garages_horaires[data-garage="' + garageName + '"] .tab_content a[data-activate="showroom-' + garageName + '"]').addClass('active');
                $('.garages_horaires--days[data-horaire="showroom-' + garageName + '"]').addClass('active');
            }
            
            // Update active state in list
            $('.garages_list--item, .garages_list_contact--item').removeClass('active');
            item.addClass('active');
            
            // Update map markers
            map.markers.forEach(function(marker) {
                if (marker.garage == item.data("garage")) {
                    // Set big icon for selected garage (format carré)
                    if (marker.iconbig) {
                        var bigIcon = L.icon({
                            iconUrl: marker.iconbig,
                            iconSize: [60, 60],  // Format carré
                            iconAnchor: [30, 30],
                            popupAnchor: [0, -20]
                        });
                        marker.setIcon(bigIcon);
                    }
                } else {
                    // Set small icon for other garages
                    var defaultIcon = L.divIcon({
                        html: '<svg width="24.92" height="24.92" viewBox="0 0 24.92 24.92" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="12.46" cy="12.46" r="12.46" fill="#dc0613" opacity=".26"/><circle cx="12.46" cy="12.46" r="7.78" fill="#dc0613"/></svg>',
                        className: 'leaflet-marker-icon',
                        iconSize: [30, 30],
                        iconAnchor: [15, 15]
                    });
                    marker.setIcon(defaultIcon);
                }
            });
        });
        
        // Handle garage list clicks for map interaction
        $('.garages_list_simple li').on('click', function() {
            var garageId = $(this).data('garage');
            
            // Highlight selected garage in list
            $('.garages_list_simple li').removeClass('active');
            $(this).addClass('active');
            
            // Find corresponding marker and center map
            map.markers.forEach(function(marker, index) {
                if (index + 1 === parseInt(garageId)) {
                    map.setView(marker.getLatLng(), 14);
                    marker.openPopup();
                    
                    // Set big icon for selected garage (format carré)
                    if (marker.iconbig) {
                        var bigIcon = L.icon({
                            iconUrl: marker.iconbig,
                            iconSize: [40, 40],  // Format carré
                            iconAnchor: [20, 20],
                            popupAnchor: [0, -20]
                        });
                        marker.setIcon(bigIcon);
                    }
                } else {
                    // Reset to default SVG icon
                    var defaultIcon = L.divIcon({
                        html: '<svg width="24.92" height="24.92" viewBox="0 0 24.92 24.92" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="12.46" cy="12.46" r="12.46" fill="#dc0613" opacity=".26"/><circle cx="12.46" cy="12.46" r="7.78" fill="#dc0613"/></svg>',
                        className: 'leaflet-marker-icon',
                        iconSize: [30, 30],
                        iconAnchor: [15, 15]
                    });
                    marker.setIcon(defaultIcon);
                }
            });
        });
        
        // Handle gamme model button clicks
        $('.gamme_model--button').on("click", function() {
            let garageName = $(this).data('garage');
            $('.garages_list--item').removeClass('active');
            $('.garages_list--item[data-garage="' + garageName + '"]').addClass('active');
            
            // Reset all markers to default SVG
            map.markers.forEach(function(marker) {
                var defaultIcon = L.divIcon({
                    html: '<svg width="24.92" height="24.92" viewBox="0 0 24.92 24.92" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="12.46" cy="12.46" r="12.46" fill="#dc0613" opacity=".26"/><circle cx="12.46" cy="12.46" r="7.78" fill="#dc0613"/></svg>',
                    className: 'leaflet-marker-icon',
                    iconSize: [30, 30],
                    iconAnchor: [15, 15]
                });
                marker.setIcon(defaultIcon);
            });
        });
    });

})(jQuery);
